module.exports = __webpack_public_path__ + "static/media/bank.a815ae38.svg";